export interface TagFormat {
  id: number;
  name: string;
  format: string;
  description: string;
  examples: string;
  type: TagType;
}

export enum TagType {
  LIST = "list",
  STRING = "string",
}
